/**
 * Path of the Dutch host landing page. It is served under a fixed path that is not a
 * supported locale prefix; the server-side twin lives in `server/util/fixedLocalePages.js`.
 */
export const NL_HOST_LANDING_PATH = '/nl/gastheer-worden';

/**
 * Extra hreflang alternates for Storyblok stories whose equivalent lives on a fixed
 * locale page, keyed by the story's `default_full_slug`.
 *
 * @type {Object<string, Array<{lang: string, path: string}>>}
 */
export const STORY_EXTRA_ALTERNATES = {
  'gastgeber-werden': [{ lang: 'nl', path: 'gastheer-worden' }],
};
